import React from 'react'

const LogoDetection = () => {
  return (
    <div>
      hello logo
    </div>
  )
}

export default LogoDetection